module.exports = __webpack_public_path__ + "img/26.2996aaf8.svg";